import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import keycloak from "@/config/keycloak";
import swal from "./plugins/swal";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VuetifyMoney from "vuetify-money";

Vue.config.productionTip = false;

Vue.use(keycloak);
Vue.use(VuetifyMoney);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

Vue.$keycloak
  .init({ checkLoginIframe: false, onLoad: "login-required" })
  .then(() => {
    new Vue({
      router,
      vuetify,
      swal,
      render: (h) => h(App),
    }).$mount("#app");
  });
